export function throttle<T extends (...args: never[]) => void>(fn: T, ms: number): T {
  let last = 0;
  return ((...args: Parameters<T>) => {
    const now = performance.now();
    if (now - last < ms) return;
    last = now;
    fn(...args);
  }) as T;
}
